import { render, staticRenderFns } from "./head1.vue?vue&type=template&id=32a96990&scoped=true"
import script from "./head1.vue?vue&type=script&lang=js"
export * from "./head1.vue?vue&type=script&lang=js"
import style0 from "./head1.vue?vue&type=style&index=0&id=32a96990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a96990",
  null
  
)

export default component.exports